import { useMemo } from "react";
import { useStore } from "@/stores/useStore";
import { useEmployeeId } from "@/hooks/useEmployeeId";
import { countMyOpenTasks } from "@/lib/taskSelectors";
import { Badge } from "@/components/Base/Badge";
import { cn } from "@/lib/utils";
import { ClassNameValue } from "tailwind-merge";

export const MyOpenTasksBadgeCount = ({
  className,
}: {
  className?: ClassNameValue;
}) => {
  const tasks = useStore((s) => s.tasks);
  const { employeeId } = useEmployeeId();

  const count = useMemo(
    () => countMyOpenTasks(tasks, employeeId),
    [tasks, employeeId]
  );

  if (count === 0) {
    return null;
  }

  return (
    <Badge
      type="small"
      variant="destructive"
      className={cn(
        "absolute -right-1 top-0.5 flex h-6 w-6 items-center justify-center text-base font-medium",
        className
      )}
    >
      {count > 9 ? "9+" : count}
    </Badge>
  );
};
